'use strict';

/**
 * Prepare data for series list.
 *
 * @param {Object} data - data to prepare
 * @param {boolean} series - is it series
 *
 * @return {Array} prepared data
 */
module.exports = function ( data, series ) {
    var result = [],
        name, index,
        className;

    data.forEach(function ( item ) {
        if ( series ) {
            name = item.name
                ? item.name + (item['original_name'] ? ' ( ' + item['original_name'] + ' )' : '')
                : gettext('Series') + ' ' + item.number;

            className = 'theme-icon theme-icon-ok hidden';

            for ( index = 0; index < item.files.length; index++ ) {
                if ( item.files[index]['watched_status'] === 'not_ended' ) {
                    className = 'theme-icon theme-icon-ok disabled';
                    break;
                }
            }

            for ( index = 0; index < item.files.length; index++ ) {
                if ( item.files[index]['watched_status'] === 'watched' ) {
                    className = 'theme-icon theme-icon-ok';
                    break;
                }
            }
        } else {
            name = item.name
                ? item.name + (item['original_name'] ? ' ( ' + item['original_name'] + ' )' : '')
                : gettext('Season') + ' ' + item.number;

            switch ( item.watched_status ) {
                case 'watched':
                    className = 'theme-icon theme-icon-ok';
                    break;
                case 'not_watched':
                    className = 'theme-icon theme-icon-ok hidden';
                    break;
                case 'not_ended':
                    className = 'theme-icon theme-icon-ok disabled';
                    break;
            }
        }
        result.push({
            items: [
                {
                    className: 'title',
                    value: name
                },
                {
                    className: className
                }

            ],
            value: item
        });
    });

    return result;
};
